import React from 'react';
import { Box, Typography } from '@mui/material';

const StatBox = ({ title, value, isSmallScreen, isTablet, icon, iconColor, backgroundColor, onClick }) => {
    return (
        <Box
            gridColumn={isSmallScreen ? 'span 12' : isTablet ? 'span 3' : 'span 2'}
            gridRow="span 1"
            borderRadius="0.55rem"
            position="relative"
            overflow="hidden"
            backgroundColor={backgroundColor}
            padding="1rem"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
            onClick={onClick}
        >
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    width: '2.5rem',
                    height: '2.5rem',
                    borderRadius: '50%',
                    backgroundColor: iconColor,
                    mb: '1rem',
                }}
            >
                {icon}
            </Box>

            <Typography variant={isTablet ? 'h3' : 'h2'} fontWeight="600" sx={{ mt: '0.5rem', ml: '0.5rem', color: 'black' }}>
                {value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </Typography>

            <Typography variant="h6" sx={{ mt: '0.5rem', mb: '1rem', ml: '0.5rem', color: 'black' }}>
                {title}
            </Typography>
        </Box>
    );
};

export default StatBox;
